import type { QueryClient } from '@tanstack/react-query';
import { outreachQueryKeys } from '@/lib/outreach/query-keys';

export async function invalidateWeekQueueCaches(
  queryClient: QueryClient,
  weekStart: string,
  leadId?: string
): Promise<void> {
  await Promise.all([
    queryClient.invalidateQueries({ queryKey: outreachQueryKeys.weekQueue(weekStart) }),
    queryClient.invalidateQueries({ queryKey: ['week-queue-leads-full'] }),
    queryClient.invalidateQueries({ queryKey: ['week-queue-contact-review'] }),
    queryClient.invalidateQueries({ queryKey: outreachQueryKeys.rollupsRoot, refetchType: 'active' }),
    queryClient.invalidateQueries({ queryKey: ['leads'] }),
    leadId
      ? queryClient.invalidateQueries({ queryKey: outreachQueryKeys.events(leadId) })
      : Promise.resolve(),
    leadId ? queryClient.invalidateQueries({ queryKey: ['lead-week-queue', leadId] }) : Promise.resolve(),
  ]);
}
